import { defineStore } from 'pinia'
import { useCookies } from 'vue3-cookies'
import { userProfileSchema, type UserProfile } from '@/models/api/user-profile'

export const useUserProfileStore = defineStore('userInfo', () => {
  const { cookies } = useCookies()
  const userInfo = ref<UserProfile | null>(null)
  const USERINFO = '_user_info'

  const setUserInfo = (data: UserProfile) => {
    if (!data) {
      return
    }

    const isUserProfile = userProfileSchema.safeParse(data).success

    if (isUserProfile) {
      userInfo.value = {
        ...userInfo.value,
        ...data
      }
    }
    cookies.set(USERINFO, JSON.stringify(userInfo.value))
  }

  const hasUserInfo = computed((): boolean => {
    if (userInfo.value === null) {
      return false
    }
    return userInfo.value !== null && Object.keys(userInfo.value).length > 0
  })

  /**
   * 從 Cookies 取得使用者資料，並寫入 Store
   */
  function setUserInfoByCookies(): boolean {
    setUserInfo(cookies.get(USERINFO) as unknown as UserProfile)
    return hasUserInfo.value
  }

  const getUserInfo = (key?: string) => {
    if (!userInfo.value) {
      return
    }

    if (key) {
      return (userInfo.value as Record<string, any>)[key]
    }
    return userInfo.value
  }

  const resetUserInfo = () => {
    userInfo.value = null
    cookies.remove(USERINFO)
  }

  return {
    userInfo,
    setUserInfo,
    setUserInfoByCookies,
    resetUserInfo,
    getUserInfo,
    hasUserInfo
  }
})
